import {
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  ListItemText,
  MenuItem,
  Select,
} from "@mui/material";
import {
  DataGrid,
  GridRowEditStopReasons,
  GridRowModes,
  useGridApiContext,
} from "@mui/x-data-grid";
import React, { useState } from "react";
import { display_advice } from "src/apis/process_response";
import { updateUser, updateUserdata } from "src/apis/user_apis";
import { getServerInfo } from "src/util/auth";
import { AccountDataColumns } from "./DataGridColumns";
import ButtonPolicy from "../Permission/ButtonPolicy";
import DailogContainer from "../DailogContainer";
import "./DataGridContainer.css";
import { deleteUser } from "src/apis/user_apis";
import { useAlertContext } from "src/hooks/use-alert";

const DataGridContainer = ({
  type,
  tableRows,
  roles,
  data,
  setData,
  setSuccess,
  setOutcome,
  setadvice,
  filteredData,
}) => {
  const alert = useAlertContext();
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 150,
        width: 250,
        marginTop: 5,
      },
    },
  };
  const [rowModesModel, setRowModesModel] = useState({});
  const [detailOpen, setDetailOpen] = useState(false);
  const [deleteDetailOpen, setDeleteDetailOpen] = useState(false);
  const [deleteUserInfo, setDeleteUserInfo] = useState("");
  const [deleteText, setDeleteText] = useState("");
  const [selectedRowData, setSelectedRowData] = useState(null);
  const selectOptions =
    type === "Account Management" && roles.map((role) => role.name);

  const handleRowEditStop = (params, event) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };

  const handleEditClick = (id) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
  };

  const handleSaveClick = (id) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
  };

  const processRowUpdate = (newRow) => {
    const newTableRoles = data.find((data) => data.id === newRow.id);
    const updatedRow = { ...newRow, ap_id: newTableRoles.ap_id, isNew: false };
    const updatedRoles = updatedRow.role.map((updatedRole) => {
      return roles.find((role) => role.name === updatedRole);
    });
    tableRowUpdated(updatedRow, updatedRoles);
    return updatedRow;
  };

  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  const tableRowUpdated = async (updatedRow, updatedRoles) => {
    const info = getServerInfo();
    const url = info[0];
    const token = info[1];
    const newRoleArr = updatedRoles.map(({ name, ...rest }) => {
      return rest;
    });
    updatedRow.role = newRoleArr;
    const body = updateUserdata(updatedRow);
    updateUser(updatedRow.ap_id, body, token)
      .then((response) => {
        if (response.status === 200) {
          const userData = response.data;
          console.log("API RESPONSE : ", userData);
          const result = display_advice(userData);
          setSuccess(result[0]);
          setOutcome(true);
          setadvice("Succesfully updated");
        }
        setData((prevData) =>
          prevData.map((row) =>
            row.id === updatedRow.ap_id
              ? { id: updatedRow.ap_id, ...updatedRow }
              : row
          )
        );
      })
      .catch((error) => {
        console.error(error.message, "Error updating");
      });
  };

  const handleDelete = (id) => {
    const userInfo = filteredData.find((row) => row.id === id);
    setDeleteDetailOpen(true);
    setDeleteUserInfo(userInfo);
    setDeleteText(`Are you sure you want to delete user "${id}"`);
  };

  // Callback function to confirm the delete in child component
  const handleConfirmChange = () => {
    handleConfirmDelete();
  };

  const handleConfirmDelete = async () => {
    const info = getServerInfo();
    const url = info[0];
    const token = info[1];
    try {
      const response = await deleteUser(deleteUserInfo.ap_id, token);
      if (response.success === true) {
        // Remove the deleted user from the users list
        const updatedData = data.filter((row) => row.id !== deleteUserInfo.id);
        setData(updatedData);
        alert.setSuccess((prev) => [
          ...prev,
          {
            status: true,
            message: "User deleted succesfully",
            index: prev.length,
          },
        ]);
      } else {
        alert.setError((prev) => [
          ...prev,
          {
            status: true,
            messages: "Deletion not succesfull",
            index: prev.length,
          },
        ]);
      }
    } catch (error) {
      console.error("Error deleting user:", error);
      alert.setError((prev) => [
        ...prev,
        {
          status: true,
          messages: "Error deleting user",
          index: prev.length,
        },
      ]);
    }
    setDeleteDetailOpen(false);
  };

  const handleView = (id) => {
    const row = data.find((row) => row.id === id);
    setSelectedRowData(row);
    setDetailOpen(true);
  };

  const handleCloseDetail = () => {
    setDetailOpen(false);
  };

  const tableColumns1 = AccountDataColumns.map((column) => {
    if (column.field === "role") {
      return {
        ...column,
        editable: true,
        type: "multiSelect",
        valueOptions: selectOptions,
        renderEditCell: CustomRoleEditCell,
        valueFormatter: ({ value }) => (value ? value.join(",") : ""),
      };
    }
    return { ...column, editable: true };
  });

  const accoutColumns = [
    ...tableColumns1,
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      flex: 1,
      cellClassName: "actions",
      getActions: ({ id }) => {
        const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;
        return [
          <div>
            <button
              style={{ padding: "5px 7px 5px 7px" }}
              onClick={isInEditMode ? handleSaveClick(id) : handleEditClick(id)}
            >
              {isInEditMode ? "Save" : "Edit"}
            </button>
            <button
              style={{ padding: "5px 7px 5px 7px" }}
              onClick={() => handleDelete(id)}
            >
              Delete
            </button>
            <button
              style={{ padding: "5px 7px 5px 7px" }}
              onClick={() => handleView(id)}
            >
              View
            </button>
          </div>,
        ];
      },
    },
  ];

  const tableColumns = type === "Account Management" && accoutColumns;

  function CustomRoleEditCell(params) {
    const { id, value, field } = params;
    const apiRef = useGridApiContext();

    const handleChange = (event) => {
      const newValue = event.target.value;
      apiRef.current.setEditCellValue({ id, field, value: newValue });
    };

    return (
      <Select
        labelId={`multi-select-${field}-label`}
        id={`multi-select-${field}`}
        multiple
        value={value}
        onChange={handleChange}
        renderValue={(selected) => selected.join(", ")}
        MenuProps={MenuProps}
        sx={{
          height: "100%",
          width: "100%",
          border: "none",
          textAlign: "center",
        }}
      >
        {selectOptions.map((option) => (
          <MenuItem key={option} value={option} sx={{ border: "none" }}>
            <Checkbox checked={value.includes(option)} name={option} />
            <ListItemText primary={option} />
          </MenuItem>
        ))}
      </Select>
    );
  }

  return (
    <div className="accountDataGrid">
      <DataGrid
        style={{
          color: "white",
          height: "max-content",
          backgroundColor: "#282b30",
          overflow: "hidden",
        }}
        rows={tableRows}
        columns={tableColumns}
        editMode="row"
        rowModesModel={rowModesModel}
        onRowModesModelChange={handleRowModesModelChange}
        onRowEditStop={handleRowEditStop}
        processRowUpdate={processRowUpdate}
        experimentalFeatures={{ newEditingApi: true }}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
        sx={{
          ".MuiInputBase-input": { backgroundColor: "#282b30", color: "white" },
          ".MuiSvgIcon-root ": {
            fill: "white !important",
          },
          ".MuiDataGrid-selectedRowCount": {
            color: "#282b30",
          },
          ".css-axafay-MuiDataGrid-virtualScroller": {
            maxHeight: "300px !important",
          },
        }}
      />
      <Dialog open={detailOpen} onClose={handleCloseDetail}>
        <DialogContent className="viewCard">
          {selectedRowData && (
            <div className="viewContents">
              <div>User Name: {selectedRowData.id}</div>
              <div>First Name: {selectedRowData.FirstName}</div>
              <div>Last Name: {selectedRowData.LastName}</div>
              <div>Phone Number: {selectedRowData.PhoneNumber}</div>
              <div>Email: {selectedRowData.Email}</div>
              <div>Role: {selectedRowData.Role.join(", ")}</div>
              {/* Add other fields as needed */}
            </div>
          )}
        </DialogContent>
        <DialogActions className="viewCard">
          <ButtonPolicy onClick={handleCloseDetail}>close</ButtonPolicy>
        </DialogActions>
      </Dialog>
      {deleteDetailOpen && (
        <DailogContainer
          detailOpen={deleteDetailOpen}
          setDetailOpen={setDeleteDetailOpen}
          text={deleteText}
          onToggleChange={handleConfirmChange}
        />
      )}
    </div>
  );
};

export default DataGridContainer;
